import { useCallback } from "react";

import { useDispatch } from "react-redux";

import { useRequestWithFeedback } from "../../../composites";
import { useObjectMemo } from "../../../hooks";

import SubscriptionsAPI from "./api";
import { actions } from "./slice";

import type { QueryParams, SubscriptionsPerCardResponse } from "./types";
import type { OverrideRunProps } from "../../../composites";

export const useSubscriptionRequests = () => {
  const dispatch = useDispatch();
  const { send, loading } =
    useRequestWithFeedback<SubscriptionsPerCardResponse>();

  const fetchCardSubscriptions = useCallback(
    (
      cardId: API.CardId,
      dateFilters?: QueryParams,
      {
        onData: overrideOnData,
        ...restRunProps
      }: OverrideRunProps<SubscriptionsPerCardResponse> = {},
    ) => {
      send({
        action: SubscriptionsAPI.getSubscriptionsForCard(cardId, dateFilters),
        onData(data) {
          dispatch(
            actions.setOne({
              card_id: cardId,
              data,
            }),
          );
          overrideOnData?.(data);
        },
        onError() {
          dispatch(actions.flush(cardId));
        },
        ...restRunProps,
      });
    },
    [dispatch, send],
  );

  return useObjectMemo({ send: fetchCardSubscriptions, loading });
};
